import PreviewScreenTitleText from "../../texts/previewScreens/PreviewScreenTitleText";
import SystemNeoUmmiaLogoTextImage from "../../images/SystemNeoUmmiaLogoTextImage";
import {useNavigate} from "react-router-dom";
import {internalRoutes} from "../../../constants/internalRoutes";
import PreviewExerciserUserCard from "../../cards/previewScreen/PreviewExerciserUserCard";
import PreviewExerciserAssignmentText from "../../texts/previewScreens/PreviewExerciserAssignmentText";

export default function PreviewExerciserSideBar({problem}) {
    // Used in PreviewExerciserScreen to display top bar
    // with device selection and disconnect button

    // PROPERTIES
    const navigate = useNavigate();

    // BUILD
    return (
        <aside className={"bg-backgroundLight1 w-[232px] min-w-[232px] h-full flex flex-col justify-start items-center border-r-[1px] border-greyLight3"}>
            <div className={"w-full flex flex-col justify-start items-center"}>
                <div className={"w-full flex flex-col justify-start items-start px-[12px] pt-[10px] pb-[12px] border-b-[1px] border-greyLight3"}>
                    <SystemNeoUmmiaLogoTextImage onLogoPressed={() => navigate(internalRoutes.home)} />
                    <PreviewScreenTitleText title={"Preview"}
                                            extraClass={"text-greyLight9"} />
                    <PreviewScreenTitleText title={"Exerciseur (" + problem?.identifier + ")"}
                                            extraClass={"text-white"} />
                </div>
            </div>
            <div className={"mb-[16px] w-full grow flex flex-col space-y-[16px] justify-between items-center px-[16px]"}>
                <PreviewExerciserAssignmentText />
                <PreviewExerciserUserCard />
            </div>
        </aside>
    )
}